function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, toRef, unref, openBlock, createElementBlock, mergeProps, Fragment, renderList, renderSlot, createVNode, normalizeClass, createBlock, createCommentVNode, normalizeProps } from 'vue';
import '../../../hooks/index.mjs';
import { skeletonProps } from './skeleton.mjs';
import SkeletonItem from './skeleton-item2.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
import { useThrottleRender } from '../../../hooks/use-throttle-render/index.mjs';
const __default__ = defineComponent({
  name: "ElSkeleton"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: skeletonProps,
  setup(__props, _ref) {
    let expose = _ref.expose;
    const props = __props;
    const ns = useNamespace("skeleton");
    const uiLoading = useThrottleRender(toRef(props, "loading"), props.throttle);
    expose({
      uiLoading
    });
    return (_ctx, _cache) => {
      return unref(uiLoading) ? (openBlock(), createElementBlock("div", mergeProps({
        key: 0,
        class: [unref(ns).b(), unref(ns).is("animated", _ctx.animated)]
      }, _ctx.$attrs), [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.count, i => {
        return openBlock(), createElementBlock(Fragment, {
          key: i
        }, [_ctx.loading ? renderSlot(_ctx.$slots, "template", {
          key: i
        }, () => [createVNode(SkeletonItem, {
          class: normalizeClass(unref(ns).is("first")),
          variant: "p"
        }, null, 8, ["class"]), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.rows, item => {
          return openBlock(), createBlock(SkeletonItem, {
            key: item,
            class: normalizeClass([unref(ns).e("paragraph"), unref(ns).is("last", item === _ctx.rows && _ctx.rows > 1)]),
            variant: "p"
          }, null, 8, ["class"]);
        }), 128))]) : createCommentVNode("v-if", true)], 64);
      }), 128))], 16)) : renderSlot(_ctx.$slots, "default", normalizeProps(mergeProps({
        key: 1
      }, _ctx.$attrs)));
    };
  }
}));
var Skeleton = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "skeleton.vue"]]);
export { Skeleton as default };